import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import { Link } from 'react-router-dom';
import { CustomIcon, CustomIconSet } from '@social-solutions/ssg-forms';
import { messagesActions } from '../dashboard/messages';
import * as authActions from '../auth/auth.actions';
import * as layoutActions from './layout.actions';
import { tenantHelpers, integrationTypes } from '../tenantInfo';
import { features, featureHelpers } from '../features';
import './header.scss';

export class Header extends Component {
  constructor(props) {
    super(props);

    this.state = {
      expandAccountLinks: false,
    }
    this.handleLogout = this.handleLogout.bind(this);
  }

  componentWillMount() {
    const { auth, messagesActions } = this.props;
    const { currentSession } = auth || {};
    const { user } = currentSession || {};
    !!user && messagesActions.fetchStats(user.id);
  }

  toggleNavbar() {
    const { layoutActions, layout } = this.props;
    const { navbarCollapsed, desktopNavCollapsed } = layout;
    !!navbarCollapsed ? layoutActions.expandNavBar() : layoutActions.collapseNavBar();
    if(navbarCollapsed) {
      this.setState({ expandAccountLinks: false });
    }

    !!desktopNavCollapsed ? layoutActions.expandDesktopNavBar() : layoutActions.collapseDesktopNavBar();
  }

  /** opens or closes the Account links dropdown based on the current state */
  toggleAccountLinks() {
    const { layoutActions } = this.props;
    const { expandAccountLinks } = this.state;
    if(!expandAccountLinks) {
      layoutActions.collapseNavBar();
    }
    this.setState({ expandAccountLinks: !expandAccountLinks });
  }

  handleLinkToNav() {
    const { layoutActions } = this.props;
    layoutActions.expandDesktopNavBar();
  }

  handleLinkToMobileNav() {
    const { layoutActions } = this.props;
    layoutActions.expandNavBar();
    this.setState({ expandAccountLinks: false });
  }

  /** redirects to the all messages page */
  handleMessagesClick(e) {
    const { redirectTo } = this.props;
    redirectTo('/messages');
  }

  handleLogout(e) {
    const { logout } = this.props.authActions;
    logout();
    this.toggleAccountLinks();
  }

  render() {
    const { auth, tenant, dashboardMessages, layout } = this.props;
    const { expandAccountLinks } = this.state;
    const { currentTenant } = tenant || {};
    const { currentSession, isAuthenticated, participantInfo } = auth || {};
    const { data } = participantInfo || {};
    const { user } = currentSession || {};
    const { firstName = '', lastName = '' } = !!data ? data : user || {};

    const { statsState } = dashboardMessages;
    const { data: messageStats } = statsState;
    const numMessages = !!messageStats ? messageStats.newMessageCount : 0

    const tenantLogoUrl = currentTenant && currentTenant.logoUrl;
    const bypassCache = `?param=${Math.random()}`;
    const logoUrl = tenantLogoUrl && tenantLogoUrl + bypassCache;
    const productName = tenantHelpers.getProductName();

    const renderLogo = (alt) => logoUrl
      ? <img className="logo" alt={alt} src={logoUrl} />
      : <bonterra-logo name="bonterra_logo_horizontal" size="24" />;
    var redirectLocation = '/';
    if ( !featureHelpers.featureEnabled(features.apricotPortalTier2) && tenantHelpers.getIntegrationType() === integrationTypes.apricot) {
      redirectLocation = "/accountinfo";
    }

    const hamburgerMenu = featureHelpers.featureEnabled(features.apricotPortalTier2) || tenantHelpers.getIntegrationType() !== integrationTypes.apricot ? (
      <button
        aria-expanded={!layout.desktopNavCollapsed}
        aria-label="toggle menu"
        id="menu-toggle-button"
        className="header-item header-button"
        onClick={e => this.toggleNavbar()}
        tabIndex={1.5}
        type="button"
      >
        <CustomIcon id="menu-icon" iconChoice={CustomIconSet.ic_menu_18x12} />
        <span className="ssg-forms-text header-button-text">Menu</span>
      </button>
    ) : null;

    const logo = (
      <div className="header-item header-logo">
        <span
          className="header-logo-centered"
          onKeyUp={(e) => {
            if (e.key === 'Enter') {
              e.currentTarget.firstChild.click();
            }
          }}
        >
          { !isAuthenticated || !user ? (
            renderLogo(`Bonterra | ${productName} logo`)
          ) : (
            <a href={redirectLocation} tabIndex={3}>
              {renderLogo(`Go to Bonterra | ${productName} Dashboard`)}
              <span className="header-logo-connect">Connect</span>
            </a>
          )}
        </span>
      </div>
    );

    const messages = featureHelpers.featureEnabled(features.apricotPortalDashboardMessages) || tenantHelpers.getIntegrationType() !== integrationTypes.apricot ? (
      <button
        aria-label="notifications"
        className="header-item header-button header-messages"
        id="header-messages"
        onClick={() => this.handleMessagesClick()}
        type="button"
      >
        <span className="header-messages-icon">
          {numMessages > 0 ? <span className="count-indicator">{numMessages}</span> : null}
          <CustomIcon id="messages" iconChoice={CustomIconSet.ic_message_18x13}/>
        </span>
        <span className="ssg-forms-text header-button-text">Notifications</span>
      </button>
    ) : null;

    const accountDropdown = (
      <div id="account-links" className="header-item header-account">
        <button
          aria-expanded={expandAccountLinks}
          aria-label={`${firstName} Connect | Participant`}
          className='header-button header-account-button'
          onClick={() => this.toggleAccountLinks()}
          tabIndex={4}
        >
          <div className="header-account-item">
            <CustomIcon
              id="user-icon"
              iconChoice={CustomIconSet.ic_portal_participants_36x36_3x}
              css={{ssgCustomIcon: 'ssg-custom-icon header-participant-icon'}}/>
          </div>
          <div className="header-account-item header-account-text">
            <div
              className="ssg-forms-text header-account-name"
            >
              {firstName} {lastName}
            </div>
            <div className="ssg-forms-text header-account-type">Participant</div>
          </div>
          <div className="header-account-item header-account-dropdown-icon">
            <CustomIcon id="down-arrow" iconChoice={CustomIconSet.ic_down_arrow_14x14}/>
          </div>
        </button>
        <ul className={"header-account-dropdown " + (!!expandAccountLinks ? "expanded" : "collapsed")}>
          <li id="account-info" className="header-account-dropdown-item">
            <Link className="header-account-link" to="/accountinfo" onClick={() => this.toggleAccountLinks()}>
              <span className="ssg-forms-text normal">Account Information</span>
            </Link>
          </li>
          <li className="header-account-dropdown-item">
            <a id="logout" className="header-account-link" href="#" onClick={this.handleLogout}>
              <span className="ssg-forms-text normal">Log Out</span>
            </a>
          </li>
        </ul>
      </div>
    );

    return (
      <nav className="connect-header">
        <ul className="screen-reader-only" aria-label="Skip Links" >
          <li className="screen-reader-only" aria-label="Skip to Menu" >
            <a
              className="skip"
              href="#menu-toggle-button"
              tabIndex={1}
            >
              Skip To Menu
            </a>
          </li>
          <li className="screen-reader-only desktop-only"  aria-label="Skip to Navigation">
            <a
              className="skip"
              href="#sidenav"
              onClick={() => this.handleLinkToNav()}
              tabIndex={1}
            >
              Skip To Navigation
            </a>
          </li>
          <li className="screen-reader-only mobile-only" aria-label="Skip to Navigation">
            <a
              className="skip"
              href="#mobile-sidenav"
              onClick={() => this.handleLinkToMobileNav()}
              tabIndex={1}
            >
              Skip To Navigation
            </a>
          </li>
          <li className="screen-reader-only" aria-label="Skip to Content">
            <a
              className="skip"
              href="#view"
              tabIndex={1}
            >
              Skip To Content
            </a>
          </li>
        </ul>
        {isAuthenticated && user ? hamburgerMenu : null}
        {logo}
        {isAuthenticated && user ? messages : null}
        {isAuthenticated && user ? accountDropdown : null}
      </nav>
    );
  }
}

Header.propTypes = {
  auth: PropTypes.any.isRequired
};

const mapDispatchToProps = (dispatch) => {
  return {
    authActions: bindActionCreators(authActions, dispatch),
    redirectTo: bindActionCreators(push, dispatch),
    messagesActions: bindActionCreators(messagesActions, dispatch),
    layoutActions: bindActionCreators(layoutActions, dispatch),
  }
}

const mapStateToProps = ({ auth, tenant, layout, dashboardMessages }) => {
  return {
    auth,
    layout,
    tenant,
    dashboardMessages,
  }
}


export default connect(mapStateToProps, mapDispatchToProps)(Header);





// WEBPACK FOOTER //
// src/layout/header.js